import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getAllNoticeAsync,
  createNoticeAsync,
  deleteNoticeAsync,
  getNoticeByIdAsync,
} from "../async.api";

const initialState = {
  noticeLoader: false,
  notices: [],
  sendNotice: [],
  deleteNotice: [],
  getNoticeByIdLoader: false,
  getNoticeById: [],
};

export const noticeSlice = createSlice({
  name: "Notice",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        getAllNoticeAsync.pending,
        createNoticeAsync.pending,
        deleteNoticeAsync.pending
      ),
      (state) => {
        state.noticeLoader = true;
      }
    );

    builder.addMatcher(isAnyOf(getNoticeByIdAsync.pending), (state) => {
      state.getNoticeByIdLoader = true;
    });
    builder.addMatcher(
      isAnyOf(getNoticeByIdAsync.fulfilled),
      (state, action) => {
        state.getNoticeByIdLoader = false;
        state.getNoticeById = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(getNoticeByIdAsync.rejected),
      (state, action) => {
        state.getNoticeByIdLoader = false;
      }
    );

    builder.addMatcher(
      isAnyOf(getAllNoticeAsync.fulfilled),
      (state, action) => {
        state.noticeLoader = false;
        state.notices = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(createNoticeAsync.fulfilled),
      (state, action) => {
        state.noticeLoader = false;
        state.sendNotice = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(deleteNoticeAsync.fulfilled),
      (state, action) => {
        state.noticeLoader = false;
        state.deleteNotice = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getAllNoticeAsync.rejected,
        createNoticeAsync.rejected,
        deleteNoticeAsync.rejected
      ),
      (state, action) => {
        state.noticeLoader = false;
      }
    );
  },
  reducers: {
    emptynotice: (state) => {
      return {
        ...initialState,
      };
    },
  },
});

export const { emptynotice } = noticeSlice.actions;

export default noticeSlice.reducer;
